import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RestApiService } from './rest-api.service';

/**
 * ルートログサービス.
 */
@Injectable()
export class RouteLogService {

  /**
   * コンストラクタ.
   *
   * @param restApiService RestApiService
   */
  constructor(private restApiService: RestApiService) { }

  /**
   * ルートログをサーバーに送信します.
   *
   * @param route ActivatedRoute
   * @param target APIのパス
   */
  log(route: ActivatedRoute, target: string): void {

    let _route: ActivatedRoute = route;

    while (_route.firstChild) {
      _route = _route.firstChild;
    }

    const path: string = _route.snapshot.routeConfig.path;
    const params: string = JSON.stringify(_route.snapshot.params);
    const queryParams: string = JSON.stringify(_route.snapshot.queryParams);

    this.restApiService.register(target, {
      path: path,
      params: params,
      queryParams: queryParams
    })
      .subscribe(
        () => { },
        error => {
          // アクセスログの通信なので、エラーは無視する
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/service/route-log.service.ts